import * as React from "react";
import Modal3DPreview from "../../helper/3DModalPreview";
import System from "src/helper/system";

const Modal3D = (props) => {
  const speedBoatName = System.avUserInfoData.speedBoatNameLower;
  let ManufacturerName = props?.value?.ManufacturerName;
  let ManufacturerPartNumber = props?.value?.ManufacturerPartNumber;
  let ERPMFRPartNumber = props?.value?.ERPMFRPartNumber;

  function onModalOpen(e) {
    e.preventDefault();
    Modal3DPreview.loadSpeedBoatViseScript(
      ManufacturerName,
      ManufacturerPartNumber,
      speedBoatName,
      1,
      "zip",
      0,
      ""
    );
  }

  return (
    <>
      <div className="cad-link" onClick={onModalOpen}>
        <a href={void 0}>
          <img src={`https://${speedBoatName}.componentsearchengine.com/icon.php?mna=${ManufacturerName}&mpn=${ERPMFRPartNumber}&lbl=1&lbc=016C9F&q3=1`} alt="PCB Symbol, Footprint & 3D Model" />
        </a>
      </div>
    </>
  );
};

export default Modal3D;

